<mat-toolbar class="main-toolbar">
  <mat-toolbar-row>
    <button (click)="hideSidenav()" mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button>
    <img class="brand-logo" src="assets/logo.png" alt="Vet Laser" />
    <span class="spacer"></span>
    <div class="logout">
      <a class="logout_name"> Ciao {{ (user?.first_name || user?.last_name) ? (user?.first_name + ' ' + user?.last_name) : user?.username }} </a>
      <button mat-button (click)="logout()">Esci <mat-icon class="logout_icon">exit_to_app</mat-icon></button>
    </div>
  </mat-toolbar-row>
</mat-toolbar>

<mat-drawer-container [ngClass]="{'mat-drawer-container-home' : isHome}">
  <mat-drawer [mode]="isMobile ? 'over' : 'side'" [opened]="show" class="app-sidenav">
    <div class="app-sidenav_inner">
      <mat-nav-list class="app-sidenav_nav">
        @for (route of routesData; track route) {
          <a
            mat-list-item
            class="app-sidenav_nav-item"
            [routerLink]="route.route"
            (click)="closeSidenavOnMobile()"
            routerLinkActive="app-sidenav_nav-item-active">
            <mat-icon>{{route.icon}}</mat-icon>
            <span>{{route.title}}</span>
          </a>
        }
      </mat-nav-list>
    </div>
  </mat-drawer>
  <mat-drawer-content>
    @if (!isHome) {
      <div class="content-toolbar" [ngClass]="{'content-toolbar_wide': !show}">
        <button mat-stroked-button appBackButton class="content-toolbar_back-btn">
          <mat-icon>arrow_back</mat-icon>
          <span>Indietro</span>
        </button>
        <app-breadcrumb class="content-toolbar_breadcrumb"></app-breadcrumb>
      </div>
    }

    <router-outlet></router-outlet>
    <app-loader></app-loader>

  </mat-drawer-content>
</mat-drawer-container>
